export type AppLang = 'en' | 'vi' | 'ko' | 'zh';

export const APP_LANGS: AppLang[] = ['en', 'vi', 'ko', 'zh'];

export const LANG_LABELS: Record<AppLang, string> = {
  en: 'English',
  vi: 'Tiếng Việt',
  ko: '한국어',
  zh: '中文',
};

export const LANG_SHORT: Record<AppLang, string> = {
  en: 'EN',
  vi: 'VI',
  ko: 'KO',
  zh: 'ZH',
};

/** Flag assets copied/adapted from Mphoto-Android drawables. */
export const LANG_FLAGS: Record<AppLang, string> = {
  en: '/flags/flag_english.svg',
  vi: '/flags/flag_vietnam.svg',
  ko: '/flags/flag_korea.svg',
  zh: '/flags/flag_china.svg',
};

const STORAGE_KEY = 'mphoto-ui-lang';

export function isAppLang(value: unknown): value is AppLang {
  return value === 'en' || value === 'vi' || value === 'ko' || value === 'zh';
}

/** Detect UI language from browser/OS, same logic as gallery.html (vi / ko / en). */
export function detectLang(): AppLang {
  const list: string[] = [];
  if (typeof navigator !== 'undefined') {
    if (navigator.languages?.length) {
      list.push(...navigator.languages);
    }
    if (navigator.language) {
      list.push(navigator.language);
    }
  }
  for (const item of list) {
    const code = String(item || '')
      .toLowerCase()
      .split('-')[0];
    if (code === 'vi' || code === 'ko' || code === 'en' || code === 'zh') {
      return code;
    }
  }
  return 'en';
}

/** Prefer saved user choice; otherwise detect from browser. */
export function resolveInitialLang(): AppLang {
  try {
    if (typeof localStorage !== 'undefined') {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (isAppLang(saved)) return saved;
    }
  } catch {
    // ignore storage errors
  }
  return detectLang();
}

export function persistLang(lang: AppLang): void {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, lang);
    }
  } catch {
    // ignore storage errors
  }
}
